import { render, staticRenderFns } from "./RiskAnalysisAssetTable.vue?vue&type=template&id=26503f12&scoped=true"
import script from "./RiskAnalysisAssetTable.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisAssetTable.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysisAssetTable.vue?vue&type=style&index=0&id=26503f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26503f12",
  null
  
)

export default component.exports